import * as Yup from 'yup';
import PropTypes from 'prop-types';

export const YupObjectShape = (validations) => Yup.object().shape(validations);

YupObjectShape.propTypes = {
  validations: PropTypes.instanceOf(Object).isRequired,
};
